module.exports = __webpack_public_path__ + "img/tourism.a553e7be.jpg";